
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/app/[deckId]",
      function () {
        return require("private-next-pages/app/[deckId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/app/[deckId]"])
      });
    }
  